import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';

const MedicalImagingPage = React.lazy(
  () => import('../features/medical-imaging/pages/MedicalImagingPage')
);

function MedicalImagingRoute() {
  return (
    <Suspense
      fallback={
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      }
    >
      <MedicalImagingPage />
    </Suspense>
  );
}

export default MedicalImagingRoute;
